import { Button, Flex, Form, Image, Input, Select, TableProps } from "antd";
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import placeholder from "../../../../assets/images/avatar.svg";
import TitleBar from "../../../../components/common/TitleBar";
import CustomModal from "../../../../components/ui/CustomModal";
import CustomTable from "../../../../components/ui/CustomTable";
import {
  useGetCompanyWalletQuery,
  useGetPayrollBatchDetailsQuery,
  useSentToDisbursementMutation,
} from "../../../../features/organization/contractual/Payroll/payrollApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { toast } from "../../../../lib/toast";
import {
  addCommaInNumber,
  countParPageSerialNumber,
} from "../../../../utils/number";
import { valueOrNa } from "../../../../utils/string";
import { addKeyInArray } from "../../../../utils/utils";

const PayrollBatchDetails = () => {
  const { id } = useParams();
  const [form] = Form.useForm();

  const [searchParams] = useSearchParams();
  const cycle = searchParams.get("cycle");
  const status = searchParams.get("status");

  const { open, handleOpen, handleClose } = useModal();

  const { page, limit, keyword, handleLimit, handleSearch, handlePagination } =
    useTable<any>();

  const { data, isLoading, isFetching } = useGetPayrollBatchDetailsQuery(
    {
      args: { params: { search: keyword, page, limit } },
      id: id as unknown as number,
    },
    { skip: !id }
  );

  const { data: wallets } = useGetCompanyWalletQuery({});

  const [
    sentToDisbursement,
    { isError, error, isLoading: senting, isSuccess },
  ] = useSentToDisbursementMutation();

  const handleSentToDisbursement = (values: any) => {
    if (!id) return null;
    sentToDisbursement({ payroll_batch_ids: [id], ...values });
  };

  useError(isError, error, "Sent to disbursement failed.");

  useEffect(() => {
    if (isSuccess) {
      toast("success", "Successfully batch send to disbursement");
      handleClose();
      form.resetFields();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, form]);

  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },

    {
      title: "Bondhu Name",
      dataIndex: "member",
      render: (val) => (
        <Flex align="center" gap={6}>
          <Image
            width={38}
            height={38}
            src={placeholder}
            className="rounded-full"
          />
          <span>{valueOrNa(val?.name)}</span>
        </Flex>
      ),
    },
    {
      title: "Bondhu ID",
      dataIndex: "member",
      render: (val) => valueOrNa(val?.employee_id),
    },

    {
      title: "Slab Name",
      dataIndex: "salary_slab_name",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Base Salary",
      dataIndex: "fixed_amount",
      render: (val) => `৳${addCommaInNumber(val || 0)}`,
    },
    {
      title: "KPI Score",
      dataIndex: "kpi_score_percentage",
      render: (val) => <span>{val ? `${val}%` : "n/a"}</span>,
    },
    {
      title: "Variable",
      dataIndex: "earned_variable_amount",
      render: (val) => `৳${addCommaInNumber(val || 0)}`,
    },
    {
      title: "Net Pay",
      dataIndex: "net_pay",
      render: (val) => `৳${addCommaInNumber(val || 0)}`,
    },
  ];

  return (
    <SidebarLayout title="Payroll">
      <TitleBar
        backLink="/organization/contractual/payroll"
        title={cycle as string}
      >
        {status === "pending" && (
          <Button type="primary" onClick={() => handleOpen({ type: "VIEW" })}>
            Send to Disbursement
          </Button>
        )}
      </TitleBar>

      <CustomTable
        loading={isLoading || isFetching}
        limit={limit}
        page={page}
        columns={columns}
        total={data?.data.total}
        dataSource={addKeyInArray(data?.data.details)}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search by employee"
              style={{ minWidth: 170, maxWidth: 180 }}
              onChange={(val) => handleSearch(val)}
            />
          </>
        }
      />

      <CustomModal
        footer={null}
        width={350}
        open={open.open}
        handleClose={() => {
          handleClose();
          form.resetFields();
        }}
        title="Select Wallet"
      >
        <Form
          form={form}
          size="large"
          layout="vertical"
          requiredMark="optional"
          className="custom-form"
          onFinish={handleSentToDisbursement}
        >
          <Form.Item
            label="Select Wallet"
            name={"wallet_number"}
            rules={[{ required: true, message: "Please select wallet" }]}
          >
            <Select
              allowClear
              showSearch
              optionFilterProp="label"
              options={(wallets?.data?.data?.wallets || []).map((item) => ({
                label: `${item.wallet_name} - ${item.wallet_number}`,
                value: item.wallet_number,
              }))}
              placeholder="Select"
            />
          </Form.Item>
          <Flex align="center" justify="end" gap={16}>
            <Button
              onClick={() => {
                handleClose();
                form.resetFields();
              }}
              htmlType="button"
              size="middle"
              className="h-10"
            >
              Cancel
            </Button>
            <Button
              loading={senting}
              htmlType="submit"
              size="middle"
              className="h-10"
              type="primary"
            >
              Continue
            </Button>
          </Flex>
        </Form>
      </CustomModal>
    </SidebarLayout>
  );
};

export default PayrollBatchDetails;
